"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2737],{

/***/ 26102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ custom_hooks_useLeadCountMutation; }
});

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./shared/models/endpoits/clients/lead counter/lead.counts.endpoints.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var LeadsStatic;

(function (LeadsStatic) {})(LeadsStatic || (LeadsStatic = {}));

var LeadsDynamic = {
  /**
   * @member {string}
   * @method POST
   * @version 2.0
   * @description post leads dynamic counter.
   */
  add: function add(realestate_id) {
    return "/v2/clients/realestates/".concat(realestate_id, "/lead-count");
  }
};
var LeadsCountEndpoints = _objectSpread(_objectSpread({}, LeadsDynamic), LeadsStatic);
// EXTERNAL MODULE: ./api/base-services.request.ts + 1 modules
var base_services_request = __webpack_require__(11882);
;// CONCATENATED MODULE: ./api/clients/leads counter/leads.counter.request.ts


function addLeadCount(values) {
  return (0,base_services_request/* postRequest */.j0)(LeadsCountEndpoints.add(values.params.realestate_id), values.body, true).then(function (_ref) {
    var data = _ref.data;
    return data === null || data === void 0 ? void 0 : data.data;
  });
}
;// CONCATENATED MODULE: ./custom-hooks/useLeadCountMutation.tsx



var useLeadCountMutation = function useLeadCountMutation() {
  var _useMutation = (0,useMutation/* useMutation */.D)({
    mutationFn: addLeadCount
  }),
      ADD_LEAD_COUNT_M = _useMutation.mutate;

  return {
    ADD_LEAD_COUNT_M: ADD_LEAD_COUNT_M
  };
};

/* harmony default export */ var custom_hooks_useLeadCountMutation = (useLeadCountMutation);

/***/ }),

/***/ 42979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50029);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_usr_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(48228);
/* harmony import */ var shared_components_property_card__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39470);
/* harmony import */ var shared_components_custom_carrusel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20518);
/* harmony import */ var shared_components_skeletons_property_collector_card_skeleton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58254);
/* harmony import */ var api_realestate_request__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13897);
/* harmony import */ var custom_hooks_useGetPersintParamas_hook__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53541);
/* harmony import */ var custom_hooks_useWindowsSize_hook__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51860);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(70917);





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











function PropertiesSlider(props) {
  var size = (0,custom_hooks_useWindowsSize_hook__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
  var width = size === null || size === void 0 ? void 0 : size.width;
  var ref = (0,custom_hooks_useGetPersintParamas_hook__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();

  var fetchProjectSlider = /*#__PURE__*/function () {
    var _ref = (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_usr_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee() {
      var response;
      return _usr_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,api_realestate_request__WEBPACK_IMPORTED_MODULE_7__/* .getRealestate */ ._G)(_objectSpread({
                page: 1
              }, props.filters));

            case 2:
              response = _context.sent;
              return _context.abrupt("return", response);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchProjectSlider() {
      return _ref.apply(this, arguments);
    };
  }();

  var _useMutation = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_11__/* .useMutation */ .D)([props.refRequest], fetchProjectSlider, {}),
      data = _useMutation.data,
      status = _useMutation.status,
      mutate = _useMutation.mutate;

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    mutate();
  }, []);

  if (status === "loading") {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(Section, {
      title: props.title,
      subtitle: props.subtitle
    }, []);
  }

  if ((data === null || data === void 0 ? void 0 : data.data.length) == 0) {
    var _props$withoutResults;

    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, (_props$withoutResults = props.withoutResultsComponent) !== null && _props$withoutResults !== void 0 ? _props$withoutResults : []);
  }

  if (status === "error") {
    return null;
  }

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(Section, {
    title: props.title,
    subtitle: props.subtitle
  }, data === null || data === void 0 ? void 0 : data.data.map(function (property, i) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(CardWrapper, {
      key: i,
      href: props.detailPath(property) + ref,
      target: width > 991 ? "_blank" : "",
      rel: "nofollow noopener noreferrer"
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(shared_components_property_card__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, property));
  })), props.children);
}

var Wrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("section",  true ? {
  target: "e1v6rvz43"
} : 0)( true ? {
  name: "1304793",
  styles: "width:100%;padding:50px 0;margin-bottom:50px;@media screen and (max-width: 991px){margin-bottom:0;padding-bottom:30px;}"
} : 0);

var CardWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("a",  true ? {
  target: "e1v6rvz42"
} : 0)( true ? {
  name: "lbn3p3",
  styles: "display:flex;justify-content:center;padding:10px 0px;margin:5px"
} : 0);

var Title = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("h2",  true ? {
  target: "e1v6rvz41"
} : 0)( true ? {
  name: "11m2fbk",
  styles: "width:100%;text-align:center;text-transform:uppercase;font-size:1.9rem;margin-bottom:20px;color:var(--color-blue-main);margin-top:50px"
} : 0);

var TitleSpan = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "e1v6rvz40"
} : 0)( true ? {
  name: "1a0w822",
  styles: "font-weight:300"
} : 0);

/* harmony default export */ __webpack_exports__["Z"] = (PropertiesSlider);

function Section(props) {
  var children = props.children,
      subtitle = props.subtitle,
      title = props.title;
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(Wrapper, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)("div", {
    className: "container"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(Title, null, title, " ", (0,_emotion_react__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(TitleSpan, null, subtitle)), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(shared_components_custom_carrusel__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    enablePlaceholder: true,
    placeholderItem: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(shared_components_skeletons_property_collector_card_skeleton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, null),
    numberOfPlaceholderItems: 4
  }, children)));
}

/***/ }),

/***/ 21689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50029);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_usr_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var custom_hooks_useSnackBar_hook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71652);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(50657);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(48228);
/* harmony import */ var api_messages_request__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27929);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var custom_hooks_data_layer_event_hook__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65198);
/* harmony import */ var _ContactForm__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97064);
/* harmony import */ var _message_modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36481);
/* harmony import */ var custom_hooks_useLeadCountMutation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26102);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(70917);




function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var postData = /*#__PURE__*/function () {
  var _ref = (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_usr_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(data) {
    var response;
    return _usr_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0,api_messages_request__WEBPACK_IMPORTED_MODULE_4__/* .postMessageAgent */ .Jk)(data);

          case 2:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function postData(_x) {
    return _ref.apply(this, arguments);
  };
}();

function ContactAgentDialog(props) {
  var _useLeadCountMutation = (0,custom_hooks_useLeadCountMutation__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(),
      ADD_LEAD_COUNT_M = _useLeadCountMutation.ADD_LEAD_COUNT_M;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();

  var _useDataLayerEvent = (0,custom_hooks_data_layer_event_hook__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(),
      event = _useDataLayerEvent.event;

  var open = props.open,
      onClose = props.onClose,
      defaultMessage = props.defaultMessage;

  var _useSnackBar = (0,custom_hooks_useSnackBar_hook__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(),
      showMessage = _useSnackBar.showMessage;

  var translation = (0,next_intl__WEBPACK_IMPORTED_MODULE_11__.useTranslations)("alerts.contactAgent");
  var translationAlert = (0,next_intl__WEBPACK_IMPORTED_MODULE_11__.useTranslations)("alerts.contact");

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      openSuccessDialog = _useState[0],
      setSuccessDialog = _useState[1];

  var _useMutation = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_12__/* .useMutation */ .D)(postData, {
    onSuccess: function onSuccess() {
      handleModalDialog();
      setTimeout(function () {
        handleModalDialog();
        onClose();
      }, 500);
    },
    onError: function onError() {
      return showMessage(translation("titleError"), {
        variant: "error"
      });
    }
  }),
      mutateAsync = _useMutation.mutateAsync,
      isLoading = _useMutation.isLoading;

  var handleModalDialog = function handleModalDialog() {
    setSuccessDialog(!openSuccessDialog);
  };

  var onSubmit = function onSubmit(values) {
    props.onCallBackSubmit && props.onCallBackSubmit();
    var data = {
      realstate_id: props.realestateId,
      agent_id: props.entity_info.id,
      permalink: props.realestateId ? window.location.href : "",
      client_name: values.full_name,
      client_email: values.email,
      client_phone: values.phone,
      client_message: values.message,
      "g-recaptcha-response": values.captcha,
      subscribe: values.subscribe
    };

    if (props.isAgency) {
      delete data.agent_id;
      data.agency_id = props.entity_info.id;
    }

    if (props.extraDataLayer) {
      var _router$query;

      // console.log("props.extraDataLayer", props.extraDataLayer);
      // event({
      //   event_name: "enviar_mensaje_propiedad",
      //   body: props.extraDataLayer,
      // });
      event({
        event_name: (_router$query = router.query) !== null && _router$query !== void 0 && _router$query.areferer ? "correo_agencia_propiedad" : "correo_agente_propiedad",
        body: props.extraDataLayer
      });
    }

    mutateAsync(data);
  };

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(StyledDialog, {
    open: open
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_ContactForm__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    onSubmit: onSubmit,
    onClose: onClose,
    classNameModalButton: props.classNameModalButton,
    isLoading: isLoading,
    defaultMessage: defaultMessage,
    className: props.customClass
  })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(StyledModalMessage, {
    title: translationAlert("titleSuccess"),
    body: translationAlert("bodySuccess"),
    open: openSuccessDialog,
    handleClose: handleModalDialog
  }));
}

var StyledDialog = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z,  true ? {
  target: "et1gf151"
} : 0)( true ? {
  name: "2dq3js",
  styles: "& .MuiDialog-paper{background-color:var(#efeff1);border-radius:20px;}"
} : 0);

var StyledModalMessage = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_message_modal__WEBPACK_IMPORTED_MODULE_6__/* .ModalMessage */ .P,  true ? {
  target: "et1gf150"
} : 0)( true ? {
  name: "983j4x",
  styles: "& .MuiBox-root{width:90%;border-radius:20px;max-width:400px;}"
} : 0);

/* harmony default export */ __webpack_exports__["Z"] = (ContactAgentDialog);

/***/ }),

/***/ 58254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86886);
/* harmony import */ var _mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88078);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70917);





function PropertyCardCollectionSkeleton() {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div", null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
    container: true,
    flexDirection: "column"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    variant: "rectangular",
    width: 300,
    height: 140,
    style: {
      borderRadius: 10
    }
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
    container: true,
    marginBottom: 1
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    width: "68%",
    height: 40
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    width: "80%",
    height: 20
  })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    width: "50%",
    height: 30
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    width: "80%",
    height: 30
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    width: "80%",
    height: 30
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (PropertyCardCollectionSkeleton);

/***/ })

}]);